import z from 'zod';

export const WorkstreamDefinitionSourceSummarySchema = z.object({
    integrationId: z.number(),
    integrationName: z.string(),
    connectorType: z.string(),
    count: z.number()
});
export type WorkstreamDefinitionSourceSummary = z.infer<typeof WorkstreamDefinitionSourceSummarySchema>;
